import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { Injectable } from "@angular/core";
import {
  SsoAccountFacade,
  SsoAccountCheckoutState,
  IdentityVerificationAction,
  parseNumber,
  RouteHelper,
} from "common";

@Injectable({
  providedIn: "root",
})
export class CheckoutStateGuard implements CanActivate {
  constructor(
    private router: Router,
    private ssoAccountFacade: SsoAccountFacade
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    const accountIdPath = parseNumber(
      RouteHelper.getParamValueByName(route, "accountId")
    );

    return this.ssoAccountFacade.getSsoAccountCheckoutState$().pipe(
      take(1),
      map((state: SsoAccountCheckoutState) => this.validate(state, accountIdPath))
    );
  }

  private validate(
    state: SsoAccountCheckoutState,
    accountIdPath: number
  ): boolean {
    if (state?.identityVerificationAction === IdentityVerificationAction.Skip) {
      return true;
    }

    if (accountIdPath) {
      this.router.navigate([`account/${accountIdPath}/setup`]);
      return false;
    } else {
      this.router.navigate([`account/setup`]);
      return false;
    }
  }
}
